export default "__VITE_ASSET__HRQgbPE3__"